import React from 'react';
import { useFileUploaderGallery } from './useFileUploaderGallery';
import { FileUploaderGallery } from './FileUploaderGallery';

/**
 * Componente que debe renderizarse una sola vez en la raíz de la aplicación
 * (App.tsx o similar) para permitir el uso del método global openGallery().
 */
export const FileUploaderGalleryGlobal: React.FC = () => {
  const { isOpen, galleryProps, closeGallery, updateResources } = useFileUploaderGallery();

  if (!isOpen || !galleryProps) return null;

  return (
    <FileUploaderGallery 
      {...galleryProps} 
      onResourceCheck={(uuid, checked, selected) => {
        // First update internal state of store
        updateResources(uuid, checked);
        // Then call the original callback from props if it exists with the selected items
        galleryProps.onResourceCheck?.(uuid, checked, selected);
      }}
      onUpload={async (file) => {
        if (galleryProps.onUpload) {
          await galleryProps.onUpload(file);
        }
      }}
      onDelete={async (uuid) => {
        if (galleryProps.onDelete) {
          await galleryProps.onDelete(uuid);
        }
      }}
      onClose={() => {
        galleryProps.onClose?.();
        closeGallery();
      }}
      // Intercept local clear to clear global store too
      error={galleryProps.error}
    />
  );
};
